import * as React from 'react';

function SvgPropertyListBlacksheep(props) {
  return (
    <svg width={12} height={12} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#property-list-blacksheep_svg__clip0_150_6107)">
        <path
          d="M2.455 1.338a.844.844 0 10-1.535.7l2.297 5.039a.844.844 0 001.323.285l1.6-1.399L7.593 8.8a.795.795 0 00.005.01L5.97 10.435a.422.422 0 00.299.72h4.043a.844.844 0 00.844-.844V6.269a.422.422 0 00-.72-.298L8.852 7.555 7.149 4.232a.844.844 0 00-1.306-.25l-1.56 1.364-1.828-4.008z"
          fill="#fff"
        />
      </g>
      <defs>
        <clipPath id="property-list-blacksheep_svg__clip0_150_6107">
          <path fill="#fff" d="M0 0h12v12H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgPropertyListBlacksheep;
